import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EstruturaRetornoDadosPaginadosOutputDto } from '../domain/DTOs/output/estrutura-retorno-dados-paginados.output.dto';
import { EstruturaRetornoDadosOutputDto } from '../domain/DTOs/output/estrutura-retorno-dados.output.dto';
import { MateriaPublicadaHtmlHierarquiaOutputDto } from '../domain/DTOs/output/publicacao/materia-publicada-html-hierarquia-output.dto';
import { CalendarioEdicaoPublicadaOutputDto, EdicaoPublicadaPortalOutputDto } from '../domain/DTOs/output/publicacao/edicao-publicada-portal-output.dto';
import { BaseService } from './base.service';
import { SumarioPublicacaoHtmlOutputDto } from '../domain/DTOs/output/publicacao/sumario-publicacao-html-output.dto';
import { ListarMateriasPublicadasHtmlInputDto } from '../domain/DTOs/input/publicacao/listar-materias-publicadas-html.input.dto';

@Injectable()
export class EdicaoPublicadaService {
  constructor(private readonly baseService: BaseService) {}

  public obterUltimaEdicao(): Observable<EstruturaRetornoDadosOutputDto<EdicaoPublicadaPortalOutputDto>> {
    return this.baseService.get('Edicao/ObterUltimaEdicaoPublicada');
  }

  public obterEdicoesPorData(dataPublicacao: string): Observable<EstruturaRetornoDadosOutputDto<EdicaoPublicadaPortalOutputDto[]>> {
    return this.baseService.get(`Edicao/ObterEdicoesPorDataPublicacao?dataPublicacao=${encodeURIComponent(dataPublicacao)}`);
  }

  public obterCalendario(ano: number, mes: number): Observable<EstruturaRetornoDadosOutputDto<CalendarioEdicaoPublicadaOutputDto[]>> {
    return this.baseService.get(`Edicao/ObterCalendarioEdicoes?Ano=${ano}&Mes=${mes}`);
  }

  public listarMaterias(inputDto: ListarMateriasPublicadasHtmlInputDto): Observable<EstruturaRetornoDadosPaginadosOutputDto<MateriaPublicadaHtmlHierarquiaOutputDto[]>> {
    const parametros = new URLSearchParams({
      EdicaoId: inputDto.edicaoId.toString(),
      PaginaAtual: inputDto.paginaAtual.toString(),
      TamanhoPagina: '10'
    });
    if (inputDto.cadernoEdicaoId) parametros.set('CadernoEdicaoId', inputDto.cadernoEdicaoId.toString());
    if (inputDto.entidadeId) parametros.set('EntidadeId', inputDto.entidadeId.toString());
    if (inputDto.municipioId) parametros.set('MunicipioId', inputDto.municipioId.toString());
    if (inputDto.secaoId) parametros.set('SecaoId', inputDto.secaoId.toString());
    if (inputDto.publicacaoId) parametros.set('PublicacaoId', inputDto.publicacaoId.toString());
    return this.baseService.get(
      `Edicao/ListarMateriasComHierarquiaPaginado?${parametros.toString()}`
    );
  }

  public obterSumario(edicaoId: number): Observable<EstruturaRetornoDadosOutputDto<SumarioPublicacaoHtmlOutputDto>> {
    return this.baseService.get(`Edicao/ObterSumarioPublicacaoHtml?edicaoId=${edicaoId}`);
  }

  public ObterPdfCadernoEdicao(id: number): Observable<HttpResponse<Blob>> {
    return this.baseService.getArquivo(`Edicao/ObterPdfCadernoEdicao/${id}`);
  }

  public ObterPdfMateriaPublicada(publicacaoId: number): Observable<HttpResponse<Blob>> {
    return this.baseService.getArquivo(`Edicao/ObterPdfMateriaPublicada/${publicacaoId}`);
  }
}
